import { FeatureFlagKey } from "stores/user/utils/resolveFlags/featureFlags.type";
import type { IconName } from "components/Icon/iconNames";

export const PROJECT_PAGES = [
  "ProjectList",
  "ProjectItem",
  "ProjectConfigurator",
];
export const PROJECT_PAGES_SAME = [
  "ProjectListSame",
  "ProjectItemSame",
  "ProjectConfigurator",
];

export const PRODUCT_PAGES = [
  "ProductList",
  "ProductConfigurator",
  "CustomProductItem",
];

export const WIZARD_PAGES = ["WizardList", "Wizard"];

export const LIBRARY_PAGES = [
  "LibraryCustom",
  "LibraryList",
  "LibraryTemplates",
];

export const SUPPORT_PAGES = ["ConfiguratorSupport"];

export const HELP_PAGES = ["ConfiguratorHelpPage"];

export const ADMIN_PAGES = ["UserList", "GroupList", "DepartmentList"];

export const PAGES_WITH_LEFT_SIDEBAR = [
  ...PROJECT_PAGES,
  ...PROJECT_PAGES_SAME,
  ...PRODUCT_PAGES,
  ...LIBRARY_PAGES,
  ...WIZARD_PAGES,
  ...ADMIN_PAGES,
  ...SUPPORT_PAGES,
];

type ButtonType = {
  title: string;
  iconName: IconName;
  refProp: string;
  pageTypes: string[];
  FEATURE_FLAG?: FeatureFlagKey;
};

export const LEFT_SIDEBAR_BUTTONS_ARRAY_CONF: ButtonType[] = [
  {
    title: "LEFT_SIDEBAR_PROJECT",
    iconName: "project-tree-light",
    refProp: "configLeftSidebarProjectRefs",
    pageTypes: PROJECT_PAGES,
    // Todo, implement flags for projects domain in the stores.
    FEATURE_FLAG: FeatureFlagKey.PROJECTS,
  },
  {
    title: "LEFT_SIDEBAR_PRODUCTS",
    iconName: "cube-light",
    refProp: "configLeftSidebarProductsRefs",
    pageTypes: PRODUCT_PAGES,
    // Todo, implement flags for products domain in the stores.
    FEATURE_FLAG: FeatureFlagKey.PRODUCTS,
  },
  {
    title: "LEFT_SIDEBAR_WIZARDS",
    iconName: "magic-wand-light",
    refProp: "configWizardObjRefs",
    pageTypes: WIZARD_PAGES,
    FEATURE_FLAG: FeatureFlagKey.WIZARDS,
  },
  {
    title: "LEFT_SIDEBAR_LIBRARY",
    iconName: "book-open-light",
    refProp: "configLeftSidebarLibraryRefs",
    pageTypes: LIBRARY_PAGES,
    // Todo, implement flags for library domain in the stores.
    FEATURE_FLAG: FeatureFlagKey.LIBRARY,
  },
];

export const LEFT_SIDEBAR_BUTTONS_ARRAY_SAME: ButtonType[] = [
  {
    title: "LEFT_SIDEBAR_PROJECT",
    iconName: "project-tree-light",
    refProp: "configLeftSidebarProjectRefs",
    pageTypes: PROJECT_PAGES_SAME,
    // Todo, implement flags for projects domain in the stores.
    FEATURE_FLAG: FeatureFlagKey.PROJECTS,
  },
  {
    title: "LEFT_SIDEBAR_PRODUCTS",
    iconName: "cube-light",
    refProp: "configLeftSidebarProductsRefs",
    pageTypes: PRODUCT_PAGES,
    // Todo, implement flags for products domain in the stores.
    FEATURE_FLAG: FeatureFlagKey.PRODUCTS,
  },
  // {
  //   title: "QUOTES",
  //   iconName: "icon-quotes",
  //   prefix: "trox",
  //   refProp: "configLeftSidebarProjectRefs",
  //   pageTypes: PROJECT_PAGES,
  // },
  // {
  //   title: "REVIEWS",
  //   iconName: "magic-wand-light",
  //   prefix: "trox",
  //   refProp: "configLeftSidebarProjectRefs",
  //   pageTypes: PROJECT_PAGES,
  // },
  // {
  //   title: "CUSTOMERS",
  //   iconName: "user-group-light",
  //   prefix: "trox",
  //   refProp: "configLeftSidebarProjectRefs",
  //   pageTypes: PROJECT_PAGES,
  // },
  // {
  //   title: "LEFT_SIDEBAR_ADMIN",
  //   iconName: "icon-admin",
  //   prefix: "trox",
  //   refProp: "configLeftSidebarAdminRefs",
  //   pageTypes: ADMIN_PAGES,
  // },
];

export const HELP_BTN: ButtonType = {
  iconName: "question-circle-light",
  refProp: "configLeftSidebarHelpRefs",
  pageTypes: HELP_PAGES,
  title: "HELP_PAGE",
};

export const SUPPORT_BTN: ButtonType = {
  iconName: "question-circle-light",
  refProp: "configLeftSidebarSupportRefs",
  pageTypes: SUPPORT_PAGES,
  title: "CONFIGURATOR_SUPPORT",
};

const [projBtn, prodBtn, wizBtn, libBtn] = LEFT_SIDEBAR_BUTTONS_ARRAY_CONF;

const [projBtnSame, prodBtnSame, admBtnSame] = LEFT_SIDEBAR_BUTTONS_ARRAY_SAME;

export const LEFT_SIDEBAR_BUTTONS = {
  projBtn,
  prodBtn,
  wizBtn,
  libBtn,
  admBtnSame,
  prodBtnSame,
  projBtnSame,
};
